/*
  ES-0004 - A/B Test Change
*/

const setupEs0004Menu = (menu) => {
  if (menu.dataset.es0004Ready === 'true') {
    return;
  }

  menu.dataset.es0004Ready = 'true';

  const activatePanel = (tab) => {
    const panelId = tab.dataset.es0004Panel;

    menu.querySelectorAll('.es-0004-menu__tab').forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    menu.querySelectorAll('.es-0004-menu__panel').forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === panelId);
    });
  };

  menu.querySelectorAll('.es-0004-menu__tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      if (tab.classList.contains('is-active')) {
        window.location.href = tab.dataset.es0004Url;
        return;
      }

      activatePanel(tab);
    });
  });

  menu.querySelector('.es-0004-menu__close')?.addEventListener('click', () => {
    const drawer = menu.closest('header-sidebar');

    if (drawer && typeof drawer.hide === 'function') {
      drawer.hide();
    } else {
      drawer?.removeAttribute('open');
    }
  });
};

const setupAllEs0004Menus = () => {
  document.querySelectorAll('.es-0004-menu').forEach(setupEs0004Menu);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupAllEs0004Menus);
} else {
  setupAllEs0004Menus();
}
